import { RouteObject } from 'react-router-dom'
import { PageLayout } from '$components/common'
import { default as Suppliers } from '.'

export const stockSupplierRoutes: RouteObject[] = [
  {
    path: '/stock/suppliers',
    element: (
      <PageLayout title="Manage Suppliers" displayLeftTitle={false}>
        <Suppliers.Suppliers.Component />
      </PageLayout>
    ),
    loader: Suppliers.Suppliers.Loader,
  },
]
